import update from 'immutability-helper';
import boardAccountsActions from '../actions/boardAccountsActions';

const boardAccountsReducer = (state = [], action) => {
  const itemIndex = state.findIndex((item) => item.id === action?.payload?.id);

  switch (action.type) {
    case boardAccountsActions.constants.set:
      return action.payload;

    case boardAccountsActions.constants.add:
      return update(state, { $push: [action.payload] });

    case boardAccountsActions.constants.update:
      return update(state, {
        [itemIndex]: { $merge: action.payload },
      });

    case boardAccountsActions.constants.remove:
      return update(state, { $splice: [[itemIndex, 1]] });

    default:
      return state;
  }
};

export default boardAccountsReducer;
